// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  logId: __t.u64().primaryKey().name("log_id"),
  owner: __t.identity(),
  kind: __t.string(),
  systemId: __t.string().name("system_id"),
  sigKey: __t.string().name("sig_key"),
  text: __t.string(),
  at: __t.timestamp(),
  published: __t.bool(),
});
